import { DeviceBreakpointsType } from '@kubit/web-ui-components/types/breakpoints';
import { EmptyStateVariantType } from '../../../../../components/internal/emptyState/types/emptyStateVariantType';
import { InputErrorMessageVariantType } from '../../../../../components/internal/inputErrorMessage/types/inputErrorMessageVariantType';
import { InputHelpMessageVariantType } from '../../../../../components/internal/inputHelpMessage/types/inputHelpMessageVariantType';
import { SelectorRowType } from '../../../../../components/selectorRowV2/types/selectorRow';
import { ThirdPartyAnimationSizesType as LoaderSizesType, ThirdPartyAnimationVariantType as LoaderVariantType, } from '../../../../../designSystem/reloaded/commons/components/thirdPartyAnimation/variants';
import { FONT_WEIGHT } from '../../foundations/typography';
import { SelectorRowVariants } from '../selectorRowV2/variants';
import { ActionBottomSheetVariantType, InputBaseVariantType, InputDecorationVariantType, InputLabelVariantType, PopoverVariantType, TextVariantType, } from '../variants';
const commonStateStyles = (FOUNDATIONS, SHADOWS, STATE_TOKENS) => ({
    ...STATE_TOKENS,
    container: {
        display: 'flex',
        flex_direction: 'column',
        gap: FOUNDATIONS.spacing_150,
        ...STATE_TOKENS.container,
    },
    inputRootContainer: {
        display: 'flex',
        flex_direction: 'column',
        gap: FOUNDATIONS.spacing_150,
        ...STATE_TOKENS.inputRootContainer,
    },
    inputContainer: {
        display: 'flex',
        gap: FOUNDATIONS.spacing_150,
        padding: FOUNDATIONS.spacing_200,
        border_width: FOUNDATIONS.border_50,
        border_style: 'solid',
        border_color: FOUNDATIONS.color_neutral_border_150,
        border_radius: FOUNDATIONS.radius_comp_forms_input_radiussize,
        background_color: FOUNDATIONS.color_comp_forms_input_bg,
        min_height: FOUNDATIONS.size_450,
        ...STATE_TOKENS.inputContainer,
    },
    optionsContainer: {
        display: 'flex',
        flex_direction: 'column',
        align_items: 'flex-start',
        flex: '1',
        ...STATE_TOKENS?.optionsContainer,
        [DeviceBreakpointsType.TABLET]: {
            overflow_y: 'auto',
            margin_top: FOUNDATIONS.border_00,
            padding: `${FOUNDATIONS.spacing_00} ${FOUNDATIONS.spacing_250} ${FOUNDATIONS.spacing_200} ${FOUNDATIONS.spacing_250}`,
            ...STATE_TOKENS?.optionsContainer?.TABLET,
        },
        [DeviceBreakpointsType.MOBILE]: {
            overflow_y: 'auto',
            margin_top: FOUNDATIONS.border_00,
            padding: `${FOUNDATIONS.spacing_00} ${FOUNDATIONS.spacing_250} ${FOUNDATIONS.spacing_200} ${FOUNDATIONS.spacing_250}`,
            ...STATE_TOKENS?.optionsContainer?.MOBILE,
        },
    },
    listOptionsContainer: {
        width: '100%',
        display: 'flex',
        flex_direction: 'column',
        align_items: 'flex-start',
        max_height: FOUNDATIONS.size_1180,
        overflow: 'auto',
        ...STATE_TOKENS?.listOptionsContainer,
        [DeviceBreakpointsType.LARGE_DESKTOP]: {
            border_radius: FOUNDATIONS.radius_comp_containers_contextmenu_radiussize,
            background_color: FOUNDATIONS.color_comp_forms_input_bg,
            box_shadow: SHADOWS.shadow_40,
            // Avoid overlap with the outline in desktop
            margin_top: FOUNDATIONS.border_100,
            padding: `${FOUNDATIONS.spacing_200} ${FOUNDATIONS.spacing_100}`,
            ...STATE_TOKENS?.listOptionsContainer?.LARGE_DESKTOP,
        },
        [DeviceBreakpointsType.DESKTOP]: {
            border_radius: FOUNDATIONS.radius_comp_containers_contextmenu_radiussize,
            background_color: FOUNDATIONS.color_comp_forms_input_bg,
            box_shadow: SHADOWS.shadow_40,
            // Avoid overlap with the outline in desktop
            margin_top: FOUNDATIONS.border_100,
            padding: `${FOUNDATIONS.spacing_200} ${FOUNDATIONS.spacing_100}`,
            ...STATE_TOKENS?.listOptionsContainer?.DESKTOP,
        },
        [DeviceBreakpointsType.TABLET]: {
            max_height: 'none',
            overflow: 'unset',
            ...STATE_TOKENS?.listOptionsContainer?.TABLET,
        },
        [DeviceBreakpointsType.MOBILE]: {
            max_height: 'none',
            overflow: 'unset',
            ...STATE_TOKENS?.listOptionsContainer?.MOBILE,
        },
    },
    optionsContentContainer: {
        display: 'flex',
        flex_direction: 'column',
        height: '100%',
    },
    buttonContainer: {
        min_width: '0',
        cursor: 'pointer',
        opacity: '1',
        flex: '1',
        font_weight: FONT_WEIGHT.font_regular,
        font_variant: TextVariantType.FONT_PARAGRAPH_200,
        color: FOUNDATIONS.color_comp_forms_input_filled_font,
        text_align: 'left',
        ...STATE_TOKENS?.buttonContainer,
    },
    buttonPlaceholder: {
        font_weight: FONT_WEIGHT.font_regular,
        font_variant: TextVariantType.FONT_PARAGRAPH_200,
        color: FOUNDATIONS.color_comp_forms_input_empty_font,
        ...STATE_TOKENS?.buttonPlaceholder,
    },
    popover: {
        variant: PopoverVariantType.INPUT_SEARCH,
        ...STATE_TOKENS?.popover,
    },
    actionBottomSheet: {
        variant: ActionBottomSheetVariantType.INPUT_SEARCH_V2,
        ...STATE_TOKENS?.actionBottomSheet,
    },
    popoverContainer: {
        position: 'relative',
        ...STATE_TOKENS?.popoverContainer,
    },
    noResults: {
        ...STATE_TOKENS?.noResults,
        container: {
            width: '100%',
            display: 'flex',
            justify_content: 'center',
            padding: `${FOUNDATIONS.spacing_200} ${FOUNDATIONS.spacing_100} ${FOUNDATIONS.spacing_00} ${FOUNDATIONS.spacing_100}`,
            ...STATE_TOKENS?.noResults?.container,
            [DeviceBreakpointsType.LARGE_DESKTOP]: {
                border_radius: FOUNDATIONS.radius_comp_containers_contextmenu_radiussize,
                background_color: FOUNDATIONS.color_comp_forms_input_bg,
                box_shadow: SHADOWS.shadow_40,
                // Avoid overlap with the outline in desktop
                margin_top: FOUNDATIONS.border_100,
                ...STATE_TOKENS?.noResults?.container?.LARGE_DESKTOP,
            },
            [DeviceBreakpointsType.DESKTOP]: {
                border_radius: FOUNDATIONS.radius_comp_containers_contextmenu_radiussize,
                background_color: FOUNDATIONS.color_comp_forms_input_bg,
                box_shadow: SHADOWS.shadow_40,
                // Avoid overlap with the outline in desktop
                margin_top: FOUNDATIONS.border_100,
                ...STATE_TOKENS?.noResults?.container?.DESKTOP,
            },
        },
        textContainer: {
            width: '100%',
            padding: FOUNDATIONS.spacing_150,
            ...STATE_TOKENS?.noResults?.textContainer,
        },
        text: {
            font_variant: TextVariantType.FONT_PARAGRAPH_200,
            font_weight: FONT_WEIGHT.font_regular,
            color: FOUNDATIONS.color_comp_forms_input_filled_font,
            ...STATE_TOKENS?.noResults?.text,
        },
    },
    loader: {
        size: LoaderSizesType.SMALL,
        variant: LoaderVariantType.SECONDARY,
        ...STATE_TOKENS?.loader,
        container: {
            width: '100%',
            height: '260px',
            display: 'flex',
            flex_direction: 'column',
            justify_content: 'center',
            align_items: 'center',
            gap: FOUNDATIONS.spacing_150,
            border_radius: FOUNDATIONS.radius_comp_containers_contextmenu_radiussize,
            background_color: FOUNDATIONS.color_comp_forms_input_bg,
            box_shadow: SHADOWS.shadow_40,
            // Avoid overlap with the outline in desktop
            margin_top: FOUNDATIONS.border_100,
            ...STATE_TOKENS?.loader?.container,
            [DeviceBreakpointsType.TABLET]: {
                height: '232px',
                border_radius: 'none',
                box_shadow: 'none',
                padding: `${FOUNDATIONS.spacing_00} ${FOUNDATIONS.spacing_250} ${FOUNDATIONS.spacing_250} ${FOUNDATIONS.spacing_250}`,
                ...STATE_TOKENS?.loader?.container?.TABLET,
            },
            [DeviceBreakpointsType.MOBILE]: {
                height: '232px',
                border_radius: 'none',
                box_shadow: 'none',
                padding: `${FOUNDATIONS.spacing_00} ${FOUNDATIONS.spacing_250} ${FOUNDATIONS.spacing_250} ${FOUNDATIONS.spacing_250}`,
                ...STATE_TOKENS?.loader?.container?.MOBILE,
            },
        },
        text: {
            text_align: 'center',
            font_variant: TextVariantType.FONT_PARAGRAPH_100,
            font_weight: FONT_WEIGHT.font_regular,
            color: FOUNDATIONS.color_neutral_font_100,
            ...STATE_TOKENS?.loader?.text,
        },
    },
    secondaryLoader: {
        size: LoaderSizesType.SMALL,
        variant: LoaderVariantType.SECONDARY,
        ...STATE_TOKENS?.secondaryLoader,
        container: {
            width: '100%',
            display: 'flex',
            justify_content: 'center',
            align_items: 'center',
            padding: `${FOUNDATIONS.spacing_200} ${FOUNDATIONS.spacing_00}`,
            ...STATE_TOKENS?.secondaryLoader?.container,
        },
    },
    option: {
        variant: SelectorRowVariants.REGULAR,
        type: SelectorRowType.OPTION,
        ...STATE_TOKENS?.option,
    },
    inputBase: { variant: InputBaseVariantType.REGULAR, ...STATE_TOKENS.inputBase },
    label: { variant: InputLabelVariantType.REGULAR, ...STATE_TOKENS.label },
    leftDecoration: {
        variant: InputDecorationVariantType.INPUT_DROPDOWN_V2,
        ...STATE_TOKENS.leftDecoration,
    },
    rightDecoration: {
        variant: InputDecorationVariantType.INPUT_DROPDOWN_V2,
        ...STATE_TOKENS.rightDecoration,
    },
    errorMessage: { variant: InputErrorMessageVariantType.REGULAR, ...STATE_TOKENS.errorMessage },
    helpMessage: { variant: InputHelpMessageVariantType.REGULAR, ...STATE_TOKENS.helpMessage },
    emptyState: { variant: EmptyStateVariantType.REGULAR, ...STATE_TOKENS.emptyState },
});
export const commonStyles = (FOUNDATIONS, SHADOWS, STATE_TOKENS) => ({
    ["FOCUSED" /* InputDropdownStateType.FOCUSED */]: {
        ...commonStateStyles(FOUNDATIONS, SHADOWS, {
            ...STATE_TOKENS["FOCUSED" /* InputDropdownStateType.FOCUSED */],
            inputContainer: {
                border_color: 'transparent',
                outline_offset: 'unset',
                box_shadow: 'none',
                outline: `${FOUNDATIONS.color_comp_forms_input_active_border} solid ${FOUNDATIONS.border_100}`,
                outline_width: FOUNDATIONS.border_100,
                outline_style: 'solid',
                outline_color: FOUNDATIONS.color_comp_forms_input_active_border,
                ...STATE_TOKENS["FOCUSED" /* InputDropdownStateType.FOCUSED */]?.inputContainer,
            },
        }),
    },
    ["FILLED" /* InputDropdownStateType.FILLED */]: {
        ...commonStateStyles(FOUNDATIONS, SHADOWS, { ...STATE_TOKENS["FILLED" /* InputDropdownStateType.FILLED */] }),
    },
    ["EMPTY" /* InputDropdownStateType.EMPTY */]: {
        ...commonStateStyles(FOUNDATIONS, SHADOWS, {
            ...STATE_TOKENS["EMPTY" /* InputDropdownStateType.EMPTY */],
            buttonContainer: {
                color: FOUNDATIONS.color_comp_forms_input_empty_font,
                ...STATE_TOKENS["EMPTY" /* InputDropdownStateType.EMPTY */]?.buttonContainer,
            },
        }),
    },
    ["ERROR_EMPTY" /* InputDropdownStateType.ERROR_EMPTY */]: {
        ...commonStateStyles(FOUNDATIONS, SHADOWS, {
            ...STATE_TOKENS["ERROR_EMPTY" /* InputDropdownStateType.ERROR_EMPTY */],
            inputContainer: {
                border_color: 'transparent',
                outline: `${FOUNDATIONS.color_feedback_error_border_50} solid ${FOUNDATIONS.border_100}`,
                outline_offset: 'unset',
                box_shadow: 'none',
                background_color: FOUNDATIONS.color_comp_forms_input_error_empty_bg,
                ...STATE_TOKENS["ERROR_EMPTY" /* InputDropdownStateType.ERROR_EMPTY */]?.inputContainer,
            },
            buttonContainer: {
                color: FOUNDATIONS.color_comp_forms_input_empty_font,
                ...STATE_TOKENS["ERROR_EMPTY" /* InputDropdownStateType.ERROR_EMPTY */]?.buttonContainer,
            },
        }),
    },
    ["ERROR_FILLED" /* InputDropdownStateType.ERROR_FILLED */]: {
        ...commonStateStyles(FOUNDATIONS, SHADOWS, {
            ...STATE_TOKENS["ERROR_FILLED" /* InputDropdownStateType.ERROR_FILLED */],
            inputContainer: {
                border_color: 'transparent',
                outline: `${FOUNDATIONS.color_feedback_error_border_50} solid ${FOUNDATIONS.border_100}`,
                outline_offset: 'unset',
                box_shadow: 'none',
                background_color: FOUNDATIONS.color_comp_forms_input_error_filled_bg,
                ...STATE_TOKENS["ERROR_FILLED" /* InputDropdownStateType.ERROR_FILLED */]?.inputContainer,
            },
        }),
    },
    ["DISABLED_EMPTY" /* InputDropdownStateType.DISABLED_EMPTY */]: {
        ...commonStateStyles(FOUNDATIONS, SHADOWS, {
            ...STATE_TOKENS["DISABLED_EMPTY" /* InputDropdownStateType.DISABLED_EMPTY */],
            inputContainer: {
                background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                border_width: FOUNDATIONS.border_50,
                border_color: FOUNDATIONS.color_accent_disabled_border_100,
                ...STATE_TOKENS["DISABLED_EMPTY" /* InputDropdownStateType.DISABLED_EMPTY */]?.inputContainer,
            },
            buttonContainer: {
                color: FOUNDATIONS.color_accent_disabled_font_100,
                cursor: 'default',
                ...STATE_TOKENS["ERROR_EMPTY" /* InputDropdownStateType.ERROR_EMPTY */]?.buttonContainer,
            },
            buttonPlaceholder: {
                color: FOUNDATIONS.color_accent_disabled_font_100,
                ...STATE_TOKENS["DISABLED_EMPTY" /* InputDropdownStateType.DISABLED_EMPTY */]?.buttonPlaceholder,
            },
        }),
    },
    ["DISABLED_FILLED" /* InputDropdownStateType.DISABLED_FILLED */]: {
        ...commonStateStyles(FOUNDATIONS, SHADOWS, {
            ...STATE_TOKENS["DISABLED_FILLED" /* InputDropdownStateType.DISABLED_FILLED */],
            inputContainer: {
                background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                border_width: FOUNDATIONS.border_50,
                border_color: FOUNDATIONS.color_accent_disabled_border_100,
                ...STATE_TOKENS["DISABLED_FILLED" /* InputDropdownStateType.DISABLED_FILLED */]?.inputContainer,
            },
            buttonContainer: {
                color: FOUNDATIONS.color_accent_disabled_font_50,
                cursor: 'default',
                ...STATE_TOKENS["DISABLED_FILLED" /* InputDropdownStateType.DISABLED_FILLED */]?.buttonContainer,
            },
        }),
    },
});
//# sourceMappingURL=commonStyles.js.map